// extracted by mini-css-extract-plugin
export default {"charge-group":"FdfWp","chargeGroup":"FdfWp","charge-group-title":"R5p81","chargeGroupTitle":"R5p81"};